import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as tutorialActions from '../../tutorial.actions'

import * as tutorialSelectors from '../../tutorial.selectors'

import AnswerQuestion from '../../../Mars/Quizzes/AnswerQuestion/AnswerQuestion'

const mapDispatchToProps = (dispatch) => ({
  // no need to mock
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),

  // probably need to mock
  likeQuestion: () => console.log('question liked'),
  clearResponses: () => console.log('clear responses'),
  removeQuestion: () => console.log('remove question'),

  // Mocked
  addPopup: bindActionCreators(tutorialActions.addPopup, dispatch),
  answerQuestion: bindActionCreators(tutorialActions.answerQuestion, dispatch),
  clearFeedBack: bindActionCreators(tutorialActions.clearFeedBack, dispatch),
  endFlow: bindActionCreators(tutorialActions.endFlow, dispatch),
})

const mapStateToProps = (state) => ({
  // harcoded no need to mock
  error: false,
  loading: false,

  // mocked
  prizeCoins: tutorialSelectors.getPrizeCoins(state),
  isPenalized: false,
  feedback: tutorialSelectors.getMiningFeedBack(state),
  counters: tutorialSelectors.getCountersData(state),
  currentQuestion: tutorialSelectors.getCurrentQuestion(state),
  hideWildCardButton: !tutorialSelectors.getMiningUI(state).wildCardButton,
  hideRefuseButton: !tutorialSelectors.getMiningUI(state).refuseButton,
  isTutorial: true,
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AnswerQuestion))
